import { render, staticRenderFns } from "./TemplateHotelFlightApp.vue?vue&type=template&id=812c686a&scoped=true"
import script from "./TemplateHotelFlightApp.vue?vue&type=script&lang=js"
export * from "./TemplateHotelFlightApp.vue?vue&type=script&lang=js"
import style0 from "./TemplateHotelFlightApp.vue?vue&type=style&index=0&id=812c686a&prod&lang=css"
import style1 from "./TemplateHotelFlightApp.vue?vue&type=style&index=1&id=812c686a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812c686a",
  null
  
)

export default component.exports